export type Dimensions = {
    dateBlocksDimension: number
    dateBlockBorderRadius: number
    isMaxSizeApp: boolean
}
export const getDateBlocksDimensions = (): Dimensions => {
    const dateBlocksDimension = 43
    const dateBlockBorderRadius = 21.5
    const isMaxSizeApp = false

    return { dateBlocksDimension, dateBlockBorderRadius, isMaxSizeApp }
}
